<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-calendar-founder`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M46 42.316v.646a1 1 0 01-1 1h-2.058a1 1 0 01-.996-.91l-.027-.248C41.403 38.952 38.494 36 35.323 36h-5.668c-3.192 0-6.1 2.991-6.585 6.881l-.018.173a1 1 0 01-.996.908H20a1 1 0 01-1-1v-.646c0-4.715 3.25-8.691 7.486-9.922a8.485 8.485 0 1112.09.014C42.784 33.654 46 37.618 46 42.316zM30 10H14v1a1 1 0 01-1 1h-2a1 1 0 01-1-1v-1H6v28h8.75v4H4a2 2 0 01-2-2V8a2 2 0 012-2h6V5a1 1 0 011-1h2a1 1 0 011 1v1h16V5a1 1 0 011-1h2a1 1 0 011 1v1h6a2 2 0 012 2v9.489a16.653 16.653 0 00-4-2.449V10h-4v1a1 1 0 01-1 1h-2a1 1 0 01-1-1v-1zm-20 8h4v4h-4v-4zm0 6h4v4h-4v-4zm6-6h4v4h-4v-4zm16.538 3.962a4.485 4.485 0 100 8.97 4.485 4.485 0 000-8.97z"/></svg>
</template>
<script>

export default {
  name: 'IconCalendarFounder',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
